module.exports = __webpack_public_path__ + "img/8033147.jpg";